// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Known values for Search Audience
 */
export var KnownSearchAudience;
(function (KnownSearchAudience) {
    /**
     * Audience for Azure China
     */
    KnownSearchAudience["AzureChina"] = "https://search.azure.cn";
    /**
     * Audience for Azure Government
     */
    KnownSearchAudience["AzureGovernment"] = "https://search.azure.us";
    /**
     * Audience for Azure Public
     */
    KnownSearchAudience["AzurePublicCloud"] = "https://search.azure.com";
})(KnownSearchAudience || (KnownSearchAudience = {}));
//# sourceMappingURL=searchAudience.js.map